import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { api } from "../api";
import { BadVotersAPI } from "../../../src/apidefs";

export function CompoBadVoters() {
  const { id } = useParams<{ id: string }>();
  const [badVoters, setBadVoters] = useState<BadVotersAPI | undefined>();

  useEffect(() => {
    async function fetchBadVoters() {
      const results = await api.get<"/api/admin/compo/:id/badvoters">(
        `/api/admin/compo/${id}/badvoters`
      );

      if (api.isToast(results)) {
        return;
      }

      setBadVoters(results.sort((a, b) => Number(a.count) - Number(b.count)));
    }

    fetchBadVoters();
  }, [id]);

  if (!badVoters) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 dark:bg-slate-900">
        <div className="text-slate-500 dark:text-slate-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 px-4 pb-8 pt-16 dark:bg-slate-900">
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-6 text-2xl font-bold text-slate-800 dark:text-white">
          Slacker Voters!
        </h1>

        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-800">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-700/50">
                <th className="px-4 py-3 text-left text-sm font-medium text-slate-600 dark:text-slate-300">
                  Username
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-slate-600 dark:text-slate-300">
                  Votes
                </th>
                <th className="px-4 py-3 text-left text-sm font-medium text-slate-600 dark:text-slate-300">
                  Email
                </th>
              </tr>
            </thead>
            <tbody>
              {badVoters.map((voter, i) => (
                <tr
                  key={voter.username + i}
                  className="border-b border-slate-100 last:border-0 dark:border-slate-700/50"
                >
                  <td className="px-4 py-3 text-sm font-medium text-slate-800 dark:text-white">
                    {voter.username}
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <span
                      className={`inline-flex min-w-[2rem] justify-center rounded-full px-2 py-0.5 text-xs font-medium ${
                        Number(voter.count) === 0
                          ? "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400"
                          : Number(voter.count) < 10
                            ? "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400"
                            : "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400"
                      }`}
                    >
                      {voter.count || 0}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-500 dark:text-slate-400">
                    {voter.email}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
